import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-patient-phone-format-control-dialog",
  templateUrl: "./patient-phone-format-control-dialog.component.html",
  styleUrls: ["./patient-phone-format-control-dialog.component.css"],
})
export class PatientPhoneFormatControlDialogComponent
  implements OnInit, AfterViewInit
{
  form!: FormGroup;

  phone: string | null = null;
  mail: string | null = null;
  @ViewChild("areaInput", { static: false })
  areaInput!: ElementRef<HTMLInputElement>;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<PatientPhoneFormatControlDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { phone?: string | null; mail?: string | null },
  ) {
    this.phone = data && data.phone ? data.phone : null;
    this.mail = data && data.mail ? data.mail : null;
  }

  ngOnInit(): void {
    const parsed = this.parsePhone(this.phone);

    this.form = this.fb.group({
      countryCode: [{ value: "549", disabled: true }],
      areaCode: [parsed.areaCode, Validators.required],
      fixed: [{ value: "15", disabled: true }],
      number: [parsed.number, Validators.required],
      mail: [this.mail, [Validators.required, Validators.email]],
    });
  }

  ngAfterViewInit(): void {}

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const value = this.form.getRawValue();
    const normalizedAreaCode = (value.areaCode || "").replace(/^0+/, "");
    const normalizedMail = (value.mail || "").trim();

    const fullPhone = "549-" + normalizedAreaCode + "-" + value.number;

    this.dialogRef.close({
      phone: fullPhone,
      mail: normalizedMail,
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  private parsePhone(phone: string | null) {
    if (!phone) {
      return {
        countryCode: "549",
        areaCode: "",
        number: "",
      };
    }

    const trimmedPhone = phone.trim();

    // Soporta formato con guiones: 549-11-56069440
    // Soporta formato con guiones: 549-351-56069440
    const dashedParts = trimmedPhone.split("-").map((part) => part.trim());
    if (dashedParts.length >= 3) {
      const countryCode = dashedParts[0].replace(/\D/g, "") || "549";
      const areaCode = dashedParts[1].replace(/\D/g, "");
      const number = dashedParts.slice(2).join("").replace(/\D/g, "");

      return {
        countryCode,
        areaCode,
        number,
      };
    }

    const digits = trimmedPhone.replace(/\D/g, "");
    if (digits.length < 5) {
      return {
        countryCode: "549",
        areaCode: "",
        number: "",
      };
    }

    const countryCode = digits.substring(0, 3) || "549";
    const nationalNumber = digits.substring(3);
    const areaCodeLength = this.inferAreaCodeLength(nationalNumber);

    return {
      countryCode,
      areaCode: nationalNumber.substring(0, areaCodeLength) || "",
      number: nationalNumber.substring(areaCodeLength) || "",
    };
  }

  private inferAreaCodeLength(nationalNumber: string): number {
    const candidates = [2, 3, 4]
      .map((areaLength) => ({
        areaLength,
        localLength: nationalNumber.length - areaLength,
      }))
      .filter((candidate) => candidate.localLength >= 6 && candidate.localLength <= 8)
      .sort((a, b) => {
        const scoreA = Math.abs(8 - a.localLength);
        const scoreB = Math.abs(8 - b.localLength);

        if (scoreA !== scoreB) {
          return scoreA - scoreB;
        }

        return a.areaLength - b.areaLength;
      });

    if (candidates.length > 0) {
      return candidates[0].areaLength;
    }

    return 2;
  }
}
